import type { ReactNode } from 'react'

import { Button } from '@/components/primitives/button'

export interface ErrorStateProps {
  action?: ReactNode
  description?: string
  onRetry?: () => void
  title: string
}

export function ErrorState({ action, description, onRetry, title }: ErrorStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-[var(--color-border)] bg-[var(--color-surface-muted)] p-4">
      <p className="text-sm font-medium text-[var(--color-text-strong)]">{title}</p>
      {description ? (
        <p className="mt-1 text-sm text-[var(--color-text-muted)]">{description}</p>
      ) : null}
      {action ??
        (onRetry ? (
          <Button className="mt-3" onClick={onRetry} size="sm" variant="secondary">
            Retry
          </Button>
        ) : null)}
    </div>
  )
}
